<template>
  <div>
    <v-dialog
      v-model="value"
      color="#C9C5C6"
      persistent
      max-width="800"
      scrollable
    >
      <v-card color="#FFFFFF">
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{
            checkIdPreview == 0
              ? 'Impresión individual de etiqueta de invitado'
              : 'Impresión masiva de etiquetas de invitados'
          }}</span>
        </v-card-title>

        <div class="preview__box">
          <div class="select__zise-text px-2 py-2">
            <h3>Elige el tamaño de la etiqueta</h3>
          </div>
          <div class="select__zise-btn">
            <v-radio-group v-model="size" row style="justify-content: center">
              <v-radio
                label="Pequeña (29 x 90mm)"
                color="red"
                value="small"
              ></v-radio>
              <v-radio
                label="Grande (62 x 100mm)"
                color="red"
                value="large"
              ></v-radio>
            </v-radio-group>
          </div>

          <div class="preview__small" v-if="size === 'small'">
            <div class="preview__qr-img">
              <img
                :src="'data:image/png;base64,' + visitPersonPreview.qr"
                alt="qr_preview"
              />
            </div>
            <div class="preview__data">
              <div class="preview__data-header">
                <span>visitante</span>
              </div>
              <div class="preview__data-content">
                <h1 v-if="visitPass" class="visitant py-1">{{ pass.name }}</h1>

                <h1 v-else class="visitant py-1">
                  {{ visitPersonPreview.name }}
                </h1>
                <v-checkbox
                  color="red"
                  class="py-1"
                  v-model="checkHost"
                  hide-details
                >
                  <template v-slot:label>
                    <div class="visit py-2">
                      <h4>A QUIÉN VISITA:</h4>
                      <span>{{ visits.hostNames }}</span>
                    </div>
                  </template>
                </v-checkbox>
                <div class="checkbox__date py-3">
                  <v-checkbox
                    v-if="visit && visit.visitType === 'ONLY_ONCE'"
                    color="red"
                    v-model="checkDate"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span>Fecha {{ visits.date | formatDateA }}</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-if="visit && visit.visitType === 'ONLY_ONCE'"
                    color="red"
                    v-model="checkTime"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span>
                          {{ $t('appointments.time') }}
                          {{ visits.date | formatDateB }}
                        </span>
                      </div>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-if="visit && visit.visitType === 'RANGE'"
                    color="red"
                    v-model="checkDate"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span
                          >Vigencia del {{ visit.startDate | formatDateA }} al
                          {{ visit.endDate | formatDateA }}</span
                        >
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="preview__large" v-else>
            <div class="preview__large-header">
              <span>visitante</span>
            </div>
            <div class="preview__large-body">
              <div class="preview__large-qr">
                <img
                  :src="'data:image/png;base64,' + visitPersonPreview.qr"
                  alt="qr-preview"
                />
              </div>
              <div class="preview__large-content">
                <h1
                  class="visitant"
                  :class="{
                    'py-0': $vuetify.breakpoint.xs,
                    'py-1': $vuetify.breakpoint.xl,
                  }"
                >
                  {{ visitPersonPreview.name }}
                </h1>

                <v-checkbox
                  color="red"
                  class="py-3"
                  v-model="checkHost"
                  hide-details
                >
                  <template v-slot:label>
                    <div class="visit">
                      <h4>A QUIÉN VISITA:</h4>
                      <span>{{ visits.hostNames }}</span>
                    </div>
                  </template>
                </v-checkbox>

                <div class="checkbox__date py-3">
                  <v-checkbox
                    v-if="visit.visitType === 'ONLY_ONCE'"
                    color="red"
                    v-model="checkDate"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span>Fecha {{ visits.date | formatDateA }}</span>
                      </div>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-if="visit.visitType === 'ONLY_ONCE'"
                    color="red"
                    v-model="checkTime"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span>Hora {{ visits.date | formatDateB }}</span>
                      </div>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-if="visit.visitType === 'RANGE'"
                    color="red"
                    v-model="checkDate"
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="visit__date">
                        <span
                          >Vigencia del {{ visit.startDate | formatDateA }} al
                          {{ visit.endDate | formatDateA }}</span
                        >
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </div>

            <h2
              style="text-align: center"
              :class="{
                'py-0': $vuetify.breakpoint.xs,
                'py-2': $vuetify.breakpoint.xl,
              }"
            >
              {{ visits.branchName }}
            </h2>
          </div>
        </div>

        <v-divider class="mt-1" />

        <v-card-actions>
          <v-spacer class="mt-2" />
          <v-btn @click="cancel()" flat>
            <h6 class="btn__preview">
              <span class="btn__text-main">cerrar</span>
            </h6>
          </v-btn>

          <v-btn @click="downloadLabel" rounded color="primary" flat>
            <h6 class="btn__preview">
              <span class="btn__text-main">imprimir</span>
              <span class="btn__text-sub">etiqueta</span>
            </h6>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error v-model="toast.failed" :text="toast.text" />
  </div>
</template>

<script>
import printJS from 'print-js'
import { mapActions, mapGetters } from 'vuex'
import error from '../../Dialogs/Error'

const isSafari =
  /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)

export default {
  name: 'VisitPreviewTagModal',
  props: [
    'value',
    'visit',
    'visitPerson',
    'visitPreview',
    'checkIdPreview',
    'visitPass',
  ],
  components: {
    error,
  },
  data() {
    return {
      visitPersonPreview: {
        name: '',
        namePass: '',
        qr: '',
      },
      size: 'small',
      checkHost: true,
      checkDate: true,
      checkTime: true,
      checkHostL: true,
      checkDateL: true,
      checkTimeL: true,
      show: false,
      checkAll: false,
      empty: [],
      page: 1,
      numPages: null,
      src: '',
      fileDowload: {
        file_type: '',
      },
      toast: {
        failed: false,
        text: '',
      },
    }
  },
  watch: {
    value() {
      if (this.value) {
        if (this.visitPerson && this.visitPerson.name && this.visitPerson.qr) {
          this.visitPersonPreview.name = this.visitPerson.name
          this.visitPersonPreview.qr = this.visitPerson.qr
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      modal: 'getStatusToggleModalPreview',
    }),
    visits() {
      if (this.visitPreview) {
        return this.visitPreview
      } else {
        return ''
      }
    },
    pass() {
      if (this.visitPass) {
        return this.visitPass
      } else {
        return ''
      }
    },
  },
  methods: {
    ...mapActions(['getToggleModalPreview']),
    downloadLabel() {
      var offset = 0
      var pageSize = 20
      var checkHost = null
      var checkDate = null
      var checkTime = null
      let _size
      if (this.size === 'small') {
        _size = true
        checkHost = this.checkHost
        checkDate = this.checkDate
        checkTime = this.checkTime
      } else {
        _size = false
        checkHost = this.checkHostL
        checkDate = this.checkDateL
        checkTime = this.checkTimeL
      }
      /* var params = {
        page_size: pageSize,
        offset: offset,
        showHost: checkHost,
        showDate: checkDate,
        showTime: checkTime,
        isSmall: _size,
      } */

      var params = {
        page_size: pageSize,
        offset: offset,
        showHost: this.checkHost,
        showDate: this.checkDate,
        showTime: this.checkTime,
        isSmall: this.size === 'small',
      }

      params.id_visit_person = []
      if (this.checkIdPreview == 0) {
        params.id_visit_person.push(this.visitPerson.id)
      } else {
        params.id_visit_person = this.checkIdPreview
      }

      this.$store
        .dispatch('visits/downoaldLabel', {
          id: this.visit.id,
          params,
        })
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)

          if (isSafari) {
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.target = '_blank'
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            printJS({
              printable: url,
              type: 'pdf',
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.toast.text = 'Ocurrió un error al intentar descargar el archivo'
          this.toast.failed = true
        })
        .finally(() => {
          this.resetCheckBox()
          this.getToggleModalPreview()
          this.size = 'small'
          this.checkHost = true
          this.checkDate = true
          this.checkTime = true
          this.checkHostL = true
          this.checkDateL = true
          this.checkTimeL = true
          this.cancel()
        })
    },
    resetCheckBox() {
      this.$emit('reset-check', this.empty, this.checkAll)
    },
    imprimir() {
      setTimeout(() => {
        this.$refs.pdf.print()
      }, 2000)
    },
    close() {
      ;(this.size = 'small'),
        (this.checkHost = true),
        (this.checkDate = true),
        (this.checkTime = true),
        (this.checkHostL = true),
        (this.checkDateL = true),
        (this.checkTimeL = true)
      this.resetCheckBox()
    },
    cancel() {
      this.$emit('cancelled')
      this.close()
    },
  },

  mounted() {},
}
</script>

<style lang="css" scoped>
.preview__box {
  width: 100%;
  margin: auto;
}

.preview__header {
  width: 100%;
  background: #000;
  text-align: center;
}

.preview__header h1 {
  color: #fff;
  padding: 25px 0px 25px 0px;
  text-transform: uppercase;
}
.preview__large {
  width: 75%;
  margin: auto;
  border: 2px solid #000;
}
.preview__large-header {
  width: 100%;
  height: 40px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview__large-header span {
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
}
.preview__large-body {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.preview__large-qr {
  width: 40%;
}
.preview__large-qr img {
  width: 100%;
  padding: 10px;
}
.preview__large-content {
  width: 60%;
}
.preview__large-content h1 {
  text-transform: uppercase;
}
.preview__large-content h2 {
  text-align: center;
}
.select__zise-btn {
  width: 90%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preview__small {
  width: 90%;
  border: 2px solid #000;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.preview__qr-img {
  width: 30%;
}

.preview__qr-img img {
  width: 100%;
}

.preview__data {
  width: 70%;
}

.preview__data-header {
  width: 100%;
  height: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.preview__data-header span {
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
}

.preview__data-content {
  text-align: left;
  padding: 0px 15px 15px 15px;
}

.preview__data-content h1 {
  text-transform: uppercase;
}

.preview__data-content h3 {
  font-weight: 700;
}

.preview__data-content span {
  font-weight: normal;
}

.checkbox__date {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.f-w {
  font-weight: 700;
}

.v-input--selection-controls {
  margin: 0;
  padding: 0;
}

.visitante__main {
  display: inline-block;
}

.visitante__sub {
  display: inline-block;
  font-weight: normal;
}

.v-label {
  color: #000;
}

.visitant {
  font-size: 30px;
}

.visit h4 {
  font-weight: 700;
  color: #000;
  font-size: 22px;
  line-height: 24px;
}

.visit span {
  text-transform: uppercase;
  font-weight: normal;
  color: #000;
  font-size: 26px;
  line-height: 28px;
}

.visit__date {
  font-weight: normal;
  color: #000;
}

.btn__text-main {
  display: block;
  font-size: 12px;
}

.btn__text-sub {
  display: block;
  font-size: 12px;
}
.btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 575px) {
  .preview__small {
    width: 100%;
  }
  .white--text {
    font-size: 17px;
  }
  .preview__data-content {
    text-align: left;
    padding: 0px 10px 0px 10px;
  }
  .preview__data-content h1 {
    font-size: 15px;
  }
  .preview__data-content h2 {
    font-size: 15px;
    padding: 0;
  }
  .visit__date {
    font-size: 13px;
  }
  .preview__data-header {
    width: 100%;
    height: 20px;
  }

  .preview__qr-img {
    width: 30%;
  }

  .preview__qr-img img {
    width: 100%;
  }

  .preview__data {
    width: 70%;
  }
  .preview__large {
    width: 100%;
  }
  .preview__large-content h1 {
    font-size: 15px;
  }
  .preview__large h2 {
    font-size: 15px;
  }

  .btn__text-main {
    display: block;
    font-size: 10px;
  }

  .btn__text-sub {
    display: block;
    font-size: 10px;
  }
}
</style>
